export default __webpack_public_path__ + "static/media/448.47386e6f.png";